import { useSelector } from 'react-redux';
import { useFirstTimeBillingInfo } from '../../hooks/use-first-time-billing-info';
import Globals from '../../store/global-selectors';

/**
 * @typedef {{
 * inventorySourceGuid: string,
 * inventorySourceType: "Native" | "Store"
 * sellerInventoryPartnetId: string,
 * warehouseGroupName: string,
 * warehouses: Array<{
 *  name: string,
 *  inventorySourceId: string,
 *  inventorySourceExternalId: string,
 *  inventorySourceGuid: string,
 *  warehouseType: "Individual" | "Aggregate",
 *  createDate: string,
 * }>
 *  }} InventorySource
 */

/**
 * @param {Array<InventorySource>} sources
 * @param {boolean} skipAddingDefaultSource
 * @returns {object} initial ship from form
 */
export const useBuildInitialShipFrom = (sources, skipAddingDefaultSource) => {
  const shouldFavorPickup = true;
  const firstTimeBillingInfo = useFirstTimeBillingInfo(shouldFavorPickup);
  const sellerShipFroms = useSelector(Globals.selectSellerShipFroms);
  const shouldUseFirstTimeBillingInfo = sellerShipFroms.length === 0;
  const sellerHomeCountry = useSelector(Globals.selectSellerHomeCountry);
  const sellerIanaTimeZone = useSelector(Globals.selectSellerTimeZoneIANA);
  const initialAddress = {
    countryCode: sellerHomeCountry,
    ianaTimeZone: sellerIanaTimeZone,
    name: firstTimeBillingInfo.name,
    email: firstTimeBillingInfo.email,
  };
  const initialAddressWithFistTimeBillingInfo = {
    ...firstTimeBillingInfo,
    ...initialAddress,
  };

  const getInventorySource = () => {
    const nativeGroup = sources.find((source) => source.inventorySourceType === 'Native');
    const nativeWarehouses = nativeGroup?.warehouses || [];

    if (!nativeWarehouses.length || skipAddingDefaultSource) {
      return {};
    }
    if (nativeWarehouses.length === 1) {
      const warehouse = nativeWarehouses[0];
      return {
        inventorySourceType: nativeGroup.inventorySourceType,
        inventorySourceId: warehouse.inventorySourceId,
        inventorySourceExternalId: null,
      };
    }
    const theNewestWarehouse = [...nativeWarehouses].sort(
      (sourceA, sourceB) => new Date(sourceB.createDate) - new Date(sourceA.createDate),
    )[0];
    return {
      inventorySourceType: nativeGroup.inventorySourceType,
      inventorySourceId: theNewestWarehouse.inventorySourceId,
      inventorySourceExternalId: null,
    };
  };

  return {
    isDefault: false,
    originAddress: shouldUseFirstTimeBillingInfo ? initialAddressWithFistTimeBillingInfo : initialAddress,
    returnAddress: shouldUseFirstTimeBillingInfo ? initialAddressWithFistTimeBillingInfo : initialAddress,
    ...getInventorySource(),
  };
};
